import React from 'react';
import { formatNumber } from '../../utils/InfluencerIQ/format';

const InfluencerModal = ({ influencer, onClose }) => {
  if (!influencer) return null;
  
  const { details } = influencer;
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-influencer-info">
            <div className="modal-influencer-icon">#</div>
            <div>
              <div className="modal-influencer-name">{influencer.name}</div>
              <div className="modal-influencer-platform">{influencer.platform}</div>
            </div>
          </div>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          {/* Stats Grid */}
          <div className="modal-stats-grid">
            <div className="modal-stat-card">
              <div className="modal-stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div className="modal-stat-value">{formatNumber(details.avgViews)}</div>
              <div className="modal-stat-label">Avg Views</div>
            </div>
            <div className="modal-stat-card">
              <div className="modal-stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
                </svg>
              </div>
              <div className="modal-stat-value">{formatNumber(details.avgLikes)}</div>
              <div className="modal-stat-label">Avg Likes</div>
            </div>
            <div className="modal-stat-card">
              <div className="modal-stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
              </div>
              <div className="modal-stat-value">{formatNumber(details.avgComments)}</div>
              <div className="modal-stat-label">Avg Comments</div>
            </div>
            <div className="modal-stat-card">
              <div className="modal-stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
                  <polyline points="16,6 12,2 8,6"/>
                  <line x1="12" y1="2" x2="12" y2="15"/>
                </svg>
              </div>
              <div className="modal-stat-value">{formatNumber(details.avgShares)}</div>
              <div className="modal-stat-label">Avg Shares</div>
            </div>
          </div>
          
          {/* Fit Score Breakdown */}
          <div className="fit-score-section">
            <div className="fit-score-header">
              <span className="fit-score-icon">◎</span>
              <h3 className="fit-score-title">Influencer Fit Score Breakdown</h3>
            </div>
            <div className="fit-score-grid">
              {Object.entries(details.fitScoreBreakdown).map(([key, value]) => (
                <div key={key} className="fit-score-item">
                  <div className="fit-score-label-row">
                    <span className="fit-score-label">{key.charAt(0).toUpperCase() + key.slice(1)}</span>
                    <span className="fit-score-value">{value}</span>
                  </div>
                  <div className="fit-score-bar">
                    <div className="fit-score-fill" style={{ width: `${value}%` }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Strengths and Considerations */}
          <div className="insights-grid">
            <div className="insights-column">
              <div className="insights-column-header">
                <span className="insights-column-icon strengths">↗</span>
                <h4 className="insights-column-title strengths">Strengths</h4>
              </div>
              <ul className="insights-column-list">
                {details.strengths.map((item, idx) => (
                  <li key={idx}>
                    <span className="insights-bullet green" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="insights-column">
              <div className="insights-column-header">
                <span className="insights-column-icon considerations">↘</span>
                <h4 className="insights-column-title considerations">Areas to Consider</h4>
              </div>
              <ul className="insights-column-list">
                {details.areasToConsider.map((item, idx) => (
                  <li key={idx}>
                    <span className="insights-bullet yellow" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          {/* Campaign Recommendation */}
          <div className="campaign-rec-section">
            <div className="campaign-rec-header">
              <span className="campaign-rec-icon">⚡</span>
              <h3 className="campaign-rec-title">Campaign Recommendation</h3>
            </div>
            <div className="campaign-rec-card">
              <div className="campaign-rec-main">
                <div className="campaign-rec-main-title">{details.campaignRecommendation.title}</div>
                <div className="campaign-rec-main-subtitle">- {details.campaignRecommendation.subtitle}</div>
              </div>
              <div className="campaign-rec-details">
                <div className="campaign-rec-detail">
                  <span className="campaign-rec-label">Suggested Content</span>
                  <span className="campaign-rec-value">{details.campaignRecommendation.suggestedContent}</span>
                </div>
                <div className="campaign-rec-detail">
                  <span className="campaign-rec-label">Key Message</span>
                  <span className="campaign-rec-value">{details.campaignRecommendation.keyMessage}</span>
                </div>
                <div className="campaign-rec-detail">
                  <span className="campaign-rec-label">Format</span>
                  <span className="campaign-rec-value">{details.campaignRecommendation.format}</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Top Performing Content */}
          <div className="top-content-section">
            <div className="top-content-header">
              <span className="top-content-icon">◯</span>
              <h3 className="top-content-title">Top Performing Content</h3>
            </div>
            <div className="top-content-card">
              <div className="top-content-main">
                <div className="top-content-name">{details.topPerformingContent.title}</div>
                <span className="top-content-engagement">{formatNumber(details.topPerformingContent.engagements)} engagements</span>
              </div>
              <div className="top-content-type">{details.topPerformingContent.type}</div>
              <div className="top-content-stats">
                <span>{formatNumber(details.topPerformingContent.views)} views</span>
                <span>{formatNumber(details.topPerformingContent.likes)} likes</span>
                <span>{formatNumber(details.topPerformingContent.comments)} comments</span>
                <span>{formatNumber(details.topPerformingContent.shares)} shares</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="modal-btn primary">Add to Campaign</button>
          <button className="modal-btn secondary">Save for Later</button>
          <button className="modal-btn secondary">Request Media Kit</button>
        </div>
      </div>
    </div>
  );
};

export default InfluencerModal;
